var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-container"},[_c('top-nav'),(this.$route.name == 'product')?_c('product-edit'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }